import { z } from "zod"

const OffPeakSeasonSchema = z.object({
    code: z.string(),
    startDay: z.number(),
    startMonth: z.number(),
    endDay: z.number(),
    endMonth: z.number(),
})

export const OffPeakValueSchema = z.object({
    label: z.string(),
    season: OffPeakSeasonSchema,
})

export const OffPeakValuesSchema = z.array(OffPeakValueSchema)
